document.addEventListener('turbo:load', () => {
  var flatpickr_options = {
    inline: true,
    onChange: function(selectedDates, dateStr, instance) {
      var form = document.querySelector('#expected-on-form');
      Rails.fire(form, "submit")
    },
    onDayCreate: function(dObj, dStr, fp, dayElem) {
      var highlightDays = JSON.parse(fp.element.dataset.schedule || null)
      if (highlightDays.indexOf(dayElem.dateObj.toISOString().slice(0,10)) !== -1) {
        dayElem.className += " route-available";
      }
    }
  }
  flatpickr('.expected-on-picker-init', flatpickr_options)
})

document.addEventListener('turbo:load', () => {
  var flatpickr_options = {
    minDate: 'today',
    inline: true,
    onChange: function(selectedDates, dateStr, instance) {
      var input = instance._input;
      var form = input.closest('form');
      Rails.fire(form, "submit")
    }
  }
  flatpickr('.new-po-picker-init', flatpickr_options)
})

document.addEventListener('turbo:load', () => {
  var flatpickr_options = {
    inline: true,
    dateFormat: "Ymd",
    onChange: function(selectedDates, dateStr, instance) {
      var input = instance._input;
      var form = input.closest('form');
      Rails.fire(form, "submit")
    }
  }
  flatpickr('.submit-on-date-picked', flatpickr_options)
})

document.addEventListener("turbo:before-cache", function() {
  document.querySelectorAll('.flatpickr-calendar').forEach(function(el) {
    el.remove()
  })
  document.querySelectorAll("input.flatpickr-input[type='hidden']").forEach(function(input) {
    input.type = 'text'
    input.classList.remove('flatpickr-input')
    var next = input.nextElementSibling
    if (next && next.tagName === 'INPUT') next.remove()
  })
})
